import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from "@angular/core";
import { AppService } from "@irb/app.service";
import { IrbClientsEvents } from "@irb/irb-common/events";
import { OptionsFormatterService } from "../../options-formatter.service";

@Component({ standalone: false,
    selector: 'option-to-sell-cell-renderer',
    template: `
        @if (!isReadOnly) {
          <a (click)="selectOption()">{{option}}</a>
        }
        @if (isReadOnly) {
          <span>{{option}}</span>
        }
        `
})
export class OptionToSellCellRenderer implements ICellRendererAngularComp {

    _params: any;
    _option: string;
    _isReadOnly: boolean = false;
    _action: string;

    constructor(public as: AppService, 
        public optionFormatter: OptionsFormatterService) {}

    agInit(params: any): void {
        this.params = params;
        this.action = params.data.action ? params.data.action : "PURCHASE_UNDERLYING_SELL_COVER_CALL";
        this.load();
    }

    load() {
        if (this.params.data.optionSymbol !== null && this.params.data.optionSymbol !== undefined) {
            this.option = this.optionFormatter.printOptionSymbol(this.params.data.optionSymbol);
        }

        if (this.params.data.allocationId !== null && this.params.data.allocationId !== undefined && this.params.data.allocationId > 0) {
            this.isReadOnly = true;
        }
    }

    refresh(): boolean {
        return true;
    }

    selectOption() {
        this.as.fireEvent(IrbClientsEvents.SHOW_OPTION_CHAINS_DIALOG, {
            data: {
                action: this.action, 
                underlyingSymbol: this.params.data.underlyingSymbol,
                chainType: 'CALL',
                isChainTypeDisable: true,
                isTrayVisible: false
            }
        });
    }

    set params(params: any) {
        this._params = params;
    }

    get params() {
        return this._params;
    }

    set option(option: string) {
        this._option = option;
    }

    get option() {
        return this._option;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    get isReadOnly() {
        return this._isReadOnly;
    }

    set action(action: string) {
        this._action = action;
    }

    get action() {
        return this._action;
    }

}
